// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"f9d47aa9","4269":"96af590b"}[chunkId] + ".chunk.css";
};